@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.standing_instruction.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.standing_instruction.generated.resources/"

internal val Res.string.feature_standing_instruction_amount: StringResource by lazy {
      StringResource("string:feature_standing_instruction_amount", "feature_standing_instruction_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 51),
      ))
    }

internal val Res.string.feature_standing_instruction_cancel: StringResource by lazy {
      StringResource("string:feature_standing_instruction_cancel", "feature_standing_instruction_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62, 51),
      ))
    }

internal val Res.string.feature_standing_instruction_confirm: StringResource by lazy {
      StringResource("string:feature_standing_instruction_confirm", "feature_standing_instruction_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114, 56),
      ))
    }

internal val Res.string.feature_standing_instruction_creates: StringResource by lazy {
      StringResource("string:feature_standing_instruction_creates", "feature_standing_instruction_creates", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171, 104),
      ))
    }

internal val Res.string.feature_standing_instruction_delete: StringResource by lazy {
      StringResource("string:feature_standing_instruction_delete", "feature_standing_instruction_delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 408, 79),
      ))
    }

internal val Res.string.feature_standing_instruction_delete_message: StringResource by lazy {
      StringResource("string:feature_standing_instruction_delete_message", "feature_standing_instruction_delete_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 276, 131),
      ))
    }

internal val Res.string.feature_standing_instruction_details: StringResource by lazy {
      StringResource("string:feature_standing_instruction_details", "feature_standing_instruction_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 488, 56),
      ))
    }

internal val Res.string.feature_standing_instruction_downloading_receipt: StringResource by lazy {
      StringResource("string:feature_standing_instruction_downloading_receipt", "feature_standing_instruction_downloading_receipt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 545, 84),
      ))
    }

internal val Res.string.feature_standing_instruction_empty_standing_instructions: StringResource by
    lazy {
      StringResource("string:feature_standing_instruction_empty_standing_instructions", "feature_standing_instruction_empty_standing_instructions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 630, 108),
      ))
    }

internal val Res.string.feature_standing_instruction_error_fetching_si_list: StringResource by
    lazy {
      StringResource("string:feature_standing_instruction_error_fetching_si_list", "feature_standing_instruction_error_fetching_si_list", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 739, 135),
      ))
    }

internal val Res.string.feature_standing_instruction_error_oops: StringResource by lazy {
      StringResource("string:feature_standing_instruction_error_oops", "feature_standing_instruction_error_oops", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 875, 55),
      ))
    }

internal val Res.string.feature_standing_instruction_failed_to_save_changes: StringResource by
    lazy {
      StringResource("string:feature_standing_instruction_failed_to_save_changes", "feature_standing_instruction_failed_to_save_changes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 931, 91),
      ))
    }

internal val Res.string.feature_standing_instruction_from: StringResource by lazy {
      StringResource("string:feature_standing_instruction_from", "feature_standing_instruction_from", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1023, 49),
      ))
    }

internal val Res.string.feature_standing_instruction_interval: StringResource by lazy {
      StringResource("string:feature_standing_instruction_interval", "feature_standing_instruction_interval", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1073, 89),
      ))
    }

internal val Res.string.feature_standing_instruction_loading: StringResource by lazy {
      StringResource("string:feature_standing_instruction_loading", "feature_standing_instruction_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1163, 56),
      ))
    }

internal val Res.string.feature_standing_instruction_select_date: StringResource by lazy {
      StringResource("string:feature_standing_instruction_select_date", "feature_standing_instruction_select_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1220, 64),
      ))
    }

internal val Res.string.feature_standing_instruction_sending_to: StringResource by lazy {
      StringResource("string:feature_standing_instruction_sending_to", "feature_standing_instruction_sending_to", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1285, 63),
      ))
    }

internal val Res.string.feature_standing_instruction_standing_instruction_id: StringResource by
    lazy {
      StringResource("string:feature_standing_instruction_standing_instruction_id", "feature_standing_instruction_standing_instruction_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1349, 92),
      ))
    }

internal val Res.string.feature_standing_instruction_status: StringResource by lazy {
      StringResource("string:feature_standing_instruction_status", "feature_standing_instruction_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1442, 55),
      ))
    }

internal val Res.string.feature_standing_instruction_submit: StringResource by lazy {
      StringResource("string:feature_standing_instruction_submit", "feature_standing_instruction_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1498, 51),
      ))
    }

internal val Res.string.feature_standing_instruction_tile_si_activity: StringResource by lazy {
      StringResource("string:feature_standing_instruction_tile_si_activity", "feature_standing_instruction_tile_si_activity", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1550, 89),
      ))
    }

internal val Res.string.feature_standing_instruction_to: StringResource by lazy {
      StringResource("string:feature_standing_instruction_to", "feature_standing_instruction_to", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1640, 43),
      ))
    }

internal val Res.string.feature_standing_instruction_valid_from: StringResource by lazy {
      StringResource("string:feature_standing_instruction_valid_from", "feature_standing_instruction_valid_from", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1684, 63),
      ))
    }

internal val Res.string.feature_standing_instruction_valid_till: StringResource by lazy {
      StringResource("string:feature_standing_instruction_valid_till", "feature_standing_instruction_valid_till", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1748, 63),
      ))
    }

internal val Res.string.feature_standing_instruction_vpa: StringResource by lazy {
      StringResource("string:feature_standing_instruction_vpa", "feature_standing_instruction_vpa", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1812, 44),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_standing_instruction_amount", Res.string.feature_standing_instruction_amount)
  map.put("feature_standing_instruction_cancel", Res.string.feature_standing_instruction_cancel)
  map.put("feature_standing_instruction_confirm", Res.string.feature_standing_instruction_confirm)
  map.put("feature_standing_instruction_creates", Res.string.feature_standing_instruction_creates)
  map.put("feature_standing_instruction_delete", Res.string.feature_standing_instruction_delete)
  map.put("feature_standing_instruction_delete_message", Res.string.feature_standing_instruction_delete_message)
  map.put("feature_standing_instruction_details", Res.string.feature_standing_instruction_details)
  map.put("feature_standing_instruction_downloading_receipt", Res.string.feature_standing_instruction_downloading_receipt)
  map.put("feature_standing_instruction_empty_standing_instructions", Res.string.feature_standing_instruction_empty_standing_instructions)
  map.put("feature_standing_instruction_error_fetching_si_list", Res.string.feature_standing_instruction_error_fetching_si_list)
  map.put("feature_standing_instruction_error_oops", Res.string.feature_standing_instruction_error_oops)
  map.put("feature_standing_instruction_failed_to_save_changes", Res.string.feature_standing_instruction_failed_to_save_changes)
  map.put("feature_standing_instruction_from", Res.string.feature_standing_instruction_from)
  map.put("feature_standing_instruction_interval", Res.string.feature_standing_instruction_interval)
  map.put("feature_standing_instruction_loading", Res.string.feature_standing_instruction_loading)
  map.put("feature_standing_instruction_select_date", Res.string.feature_standing_instruction_select_date)
  map.put("feature_standing_instruction_sending_to", Res.string.feature_standing_instruction_sending_to)
  map.put("feature_standing_instruction_standing_instruction_id", Res.string.feature_standing_instruction_standing_instruction_id)
  map.put("feature_standing_instruction_status", Res.string.feature_standing_instruction_status)
  map.put("feature_standing_instruction_submit", Res.string.feature_standing_instruction_submit)
  map.put("feature_standing_instruction_tile_si_activity", Res.string.feature_standing_instruction_tile_si_activity)
  map.put("feature_standing_instruction_to", Res.string.feature_standing_instruction_to)
  map.put("feature_standing_instruction_valid_from", Res.string.feature_standing_instruction_valid_from)
  map.put("feature_standing_instruction_valid_till", Res.string.feature_standing_instruction_valid_till)
  map.put("feature_standing_instruction_vpa", Res.string.feature_standing_instruction_vpa)
}
